import api from "./apiClient.js";

const endpoint = "auth";

export function login(username, password, r = false) {
	const refresh = r ? "1" : "0";
	return api.post(endpoint + "/login?refresh=" + refresh, { username, password });
}

export function register(username, email, level, office) {
	return api.post(endpoint + "/register", { username, email, level, office });
}

export function changePassword(oldPassword, newPassword) {
	return api.post(endpoint + "/update-password", { oldPassword, newPassword });
}

export function getUser() {
	return api.get(endpoint + "/user");
}

export function resetPassword(id) {
	return api.get(endpoint + "/reset-password/" + id);
}

export function logoutAll() {
	return api.delete(endpoint + "/logout-all");
}

export function getActiveSessions() {
	return api.get(endpoint + "/active-sessions");
}

export function updateUser(email) {
	return api.put(endpoint + "/user", { email });
}
